import React, { Component } from 'react'
// import { connect } from 'react-redux'

// Elements
// import LabelWrapper from '../labelWrapper'
import Label from '../label'
import HelpIcon from '../helpIcon'
import Icon from '../icon'
import { ElementIcons } from '../icons'

import '../elements.scss'
import './switch.scss'

// Watch out with importing state.common together with using this switch, it can cause problems where it does not trigger onChange()

class Switch extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
    this.onChange = this.onChange.bind(this)
    this.onClick = this.onClick.bind(this)
  }

  onChange (e) {
    // console.log('Switch onChange triggered! ', e)
    if (this.props.onChange !== null) {
      this.props.onChange(e)
    }
  }

  onClick (e) {
    // console.log('Switch onClick triggered! ', e)
    if (this.props.onClick !== null) {
      this.props.onClick(e)
    }
  }

  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return ' size-large'
      case 'm':
        return ' size-medium'
      case 's':
        return ' size-small'
    }
  }

  getSolidClass () {
    return ''
  }

  getBorderClass () {
    return ''
  }

  getWidthClass () {
    if (this.props.width === null) return ''
    let width = typeof this.props.width === 'number' ? width : parseInt(this.props.width)
    return ' cnt-w-' + width
  }

  getSpacingClass () {
    let spacing = typeof this.props.spacing === 'string' ? parseInt(this.props.spacing) : this.props.spacing
    if (spacing < 1) return ''
    return ' pg-my-' + spacing
  }

  getContainerStyle () {
    switch (this.props.labelAlignment) {
      case 'r':
        return 'container label-right'
      case 'l':
        return 'container label-left'
    }
  }

  getStyle () {
    return 'element-switch' + this.getSizeClass() + this.getSpacingClass() + this.getWidthClass() + this.getSolidClass() + this.getBorderClass()
  }

  render () {
    const { simple } = this.props

    return (
      <div className={this.getStyle()}>
        <div>
          <label onClick={(e) => e.stopPropagation()} className={this.getContainerStyle()} disabled={this.props.disabled}>
            {!simple && <Label>{this.props.labelText}</Label>}

            <input
              type='checkbox'
              id={this.props.id}
              name={this.props.name}
              value={this.props.value}
              onChange={this.onChange.bind(this)}
              checked={this.props.checked}
              onClick={this.onClick.bind(this)}
              disabled={this.props.disabled}
            />

            <Icon icon={ElementIcons.Switch_On} className='on' size={this.props.size} injectSvg />
            <Icon icon={ElementIcons.Switch_Off} className='off' size={this.props.size} injectSvg />
          </label>
        </div>

        {!simple && this.props.helpText && <HelpIcon helpText={this.props.helpText} />}
      </div>
    )
  }

}

Switch.defaultProps = {
  size: 's',
  style: 'default',
  labelText: null,
  helpText: null,
  labelAlignment: 'r',
  onChange: null,
  onClick: null,
  value: false,
  checked: false,
  width: null,
  spacing: 2,
  simple: false
}

export default Switch



// WEBPACK FOOTER //
// ./src/app/shared/elements/switch/index.js